import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import cn from 'classnames';
import { clamp } from 'lodash-es';
import { intentClass, ControlShapeType, ControlSizeType, controlClasses, isDefined } from '../../../library';
export var progressCircleClasses = {
  MAIN: 'progress-circle',
  TRAIL: 'progress-circle__trail',
  PATH: 'progress-circle__meter'
};
var VIEWBOX_HEIGHT = 100;
export var ProgressCircle = function ProgressCircle(props) {
  var _props$duration, _props$duration2;
  var className = props.className,
    intent = props.intent,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    shape = props.shape,
    size = props.size,
    rotation = props.rotation,
    isCounterClockwise = props.isCounterClockwise;
  var classNames = cn(progressCircleClasses.MAIN, intentClass(intent), controlClasses({
    shape: shape,
    size: size
  }), {
    '-done': isDefined(value) && value >= 100,
    '-inverse': props.isInverse
  }, className);
  var getPathRadius = function getPathRadius() {
    return VIEWBOX_HEIGHT / 2 - getStrokeWidth() / 2;
  };
  var getPathRatio = function getPathRatio() {
    return clamp(value, 0, 100) / 100;
  };
  var getStrokeWidth = function getStrokeWidth() {
    return clamp(props.strokeWidth, 0, VIEWBOX_HEIGHT) / 2;
  };
  var getCircumferenceRatio = function getCircumferenceRatio() {
    return clamp(props.circumference, 0, 100) / 100;
  };
  var radius = getPathRadius();
  var ratio = getPathRatio();
  var strokeWidth = getStrokeWidth();
  var circumferenceRatio = getCircumferenceRatio();
  return React.createElement("div", {
    className: classNames
  }, React.createElement("svg", {
    viewBox: "0 0 ".concat(VIEWBOX_HEIGHT, " ").concat(VIEWBOX_HEIGHT)
  }, React.createElement(Path, {
    className: progressCircleClasses.TRAIL,
    isCounterClockwise: isCounterClockwise,
    radius: radius,
    rotation: rotation,
    ratio: circumferenceRatio,
    strokeWidth: strokeWidth,
    transitionDuration: (_props$duration = props.duration) !== null && _props$duration !== void 0 ? _props$duration : 0,
    value: value
  }), React.createElement(Path, {
    className: progressCircleClasses.PATH,
    isCounterClockwise: isCounterClockwise,
    radius: radius,
    rotation: rotation,
    ratio: ratio * circumferenceRatio,
    strokeWidth: strokeWidth,
    transitionDuration: (_props$duration2 = props.duration) !== null && _props$duration2 !== void 0 ? _props$duration2 : 0,
    value: value
  })));
};
ProgressCircle.displayName = "ProgressCircle";
ProgressCircle.defaultProps = {
  circumference: 100,
  isCounterClockwise: false,
  isInverse: false,
  rotation: 0,
  shape: ControlShapeType.ROUNDED,
  size: ControlSizeType.MEDIUM,
  strokeWidth: 25
};
var Path = function Path(props) {
  var transitionDuration = props.transitionDuration,
    radius = props.radius,
    ratio = props.ratio,
    isCounterClockwise = props.isCounterClockwise,
    strokeWidth = props.strokeWidth,
    rotation = props.rotation;
  var direction = isCounterClockwise ? 1 : 0;
  return React.createElement("path", {
    className: props.className,
    d: "\n        M ".concat(VIEWBOX_HEIGHT / 2, ", ").concat(VIEWBOX_HEIGHT / 2, "\n        m 0,-").concat(radius, "\n        a ").concat(radius, ", ").concat(radius, " ").concat(direction, " 1 1 0, ").concat(2 * radius, "\n        a ").concat(radius, ", ").concat(radius, " ").concat(direction, " 1 1 0, -").concat(2 * radius, "\n      "),
    strokeWidth: strokeWidth,
    fillOpacity: "0",
    transform: "rotate(".concat(rotation, ", ").concat(VIEWBOX_HEIGHT / 2, ", ").concat(VIEWBOX_HEIGHT / 2, ")"),
    style: _objectSpread(_objectSpread({}, getDashStyles({
      radius: radius,
      isCounterClockwise: isCounterClockwise,
      dashRatio: ratio
    })), {}, {
      transitionDuration: "".concat(transitionDuration, "ms")
    })
  });
};
function getDashStyles(_ref) {
  var radius = _ref.radius,
    dashRatio = _ref.dashRatio,
    isCounterClockwise = _ref.isCounterClockwise;
  var diameter = Math.PI * 2 * radius;
  var gapLength = (1 - dashRatio) * diameter;
  return {
    strokeDasharray: "".concat(diameter, "px ").concat(diameter, "px"),
    strokeDashoffset: "".concat(isCounterClockwise ? -gapLength : gapLength, "px")
  };
}